export enum AnalyseTabsValue {
  ALL_APPLICANTS = 'All_applicants',
  CANDIDATES_WITH_MINIMUM_REQUIREMENTS = 'Candidates_with_minimum_requirements',
  SOURCE_CANDIDATES = 'Source_candidates'
}
